import { OfferLetter } from '../types';

export const DEFAULT_COMPANY = {
  name: 'Shaktisetu',
  url: 'https://shaktisetu.com',
};

export function sanitizeHtml(html: string): string {
  // Minimal sanitization for this demo; server should sanitize again
  if (typeof html !== 'string') return '';
  return html.replace(/<script/gi, '&lt;script').replace(/on\w+=/gi, '');
}

export function buildOfferHtml(details: Partial<OfferLetter> | null): string {
  const {
    issueDate,
    candidateName,
    candidateAddress = '',
    jobTitle,
    employmentType,
    officeAddress,
    annualSalary,
    monthlySalary,
    placementFee,
    firstMonthNetSalary,
    joiningDate,
    workingHours,
    probationPeriod,
    noticePeriod,
    feeDeductionAmount = '2500',
    company = DEFAULT_COMPANY,
  } = details || {};

  const html = `
  <div class="offer-letter">
    <header class="letterhead">
      <div class="brand">${company.name}</div>
      <div class="meta">
        <div>Date: ${issueDate || ''}</div>
      </div>
    </header>

    <section class="recipient">
      <div>To,</div>
      <div>${candidateName || ''}</div>
      <div>${candidateAddress || ''}</div>
    </section>

    <section class="subject">
      <strong>Subject: Offer of Employment – ${jobTitle || ''}</strong>
    </section>

    <section class="greeting">
      <p>Dear ${candidateName || ''},</p>
    </section>

    <section class="body">
      <p>
        We are pleased to offer you the position of <strong>${jobTitle || ''}</strong> at
        <strong>${company.name}</strong>, employment type <strong>${employmentType || ''}</strong>.
        Your work location is <strong>Onsite</strong> at <strong>${officeAddress || ''}</strong>.
      </p>
      <p>
        Your annual compensation will be <strong>INR ${annualSalary || ''}</strong>.
        Your tentative joining date is <strong>${joiningDate || ''}</strong>.
      </p>

      <div class="key-terms">
        <div><strong>Monthly Salary</strong>: INR ${monthlySalary || ''}</div>
        <div><strong>Placement Fee</strong>: INR ${placementFee || feeDeductionAmount || '2500'}</div>
        <div><strong>Working Hours</strong>: ${workingHours || ''}</div>
        <div><strong>Probation Period</strong>: ${probationPeriod || ''}</div>
        <div><strong>Notice Period</strong>: ${noticePeriod || ''}</div>
      </div>

      <p class="clause">
        <strong>Important:</strong> An amount of <strong>INR ${feeDeductionAmount || '2500'}</strong> will be deducted from your first month's salary as a service fee to <strong>${company.name}</strong>.
      </p>

      <p class="clause">
        For the first month, your take-home salary will be <strong>INR ${firstMonthNetSalary || (monthlySalary && placementFee ? (Number(monthlySalary) - Number(placementFee || feeDeductionAmount || 0)).toFixed(2) : '')}</strong> (monthly salary INR ${monthlySalary || ''} minus placement fee INR ${placementFee || feeDeductionAmount || '2500'}). From the second month onwards, your salary will be <strong>INR ${monthlySalary || ''}</strong>.
      </p>

      <p>
        We look forward to working with you.
      </p>
    </section>

    <section class="closing">
      <div>Sincerely,</div>
      <div>${details?.recruiterName || 'Hiring Team'}</div>
      <div>${company.name}</div>
    </section>

    <footer class="footer">
      <div>${company.url}</div>
    </footer>
  </div>`;

  return sanitizeHtml(html);
}
